import React from 'react'

import IdentifierItem from './IdentifierItem'

import { FilterTypes, Content, ListItem, LoadingTable } from './styles'
import imgLoading from '../../../../static/loading.gif'

function IdentifierTable({
  editingSelection,
  editSelectionBlock,
  identificadores = [],
  selectedIdentifiers = [],
  isLoadingPagination = false
}) {
  const filteredIdentifiers =
    selectedIdentifiers && editSelectionBlock && !editingSelection
      ? selectedIdentifiers.map(identifier => {
          return {
            veiculo: {
              placa: identifier.placa
            }
          }
        })
      : identificadores

  return (
    <Content isLoadingPagination={isLoadingPagination}>
      {isLoadingPagination ? (
        <LoadingTable src={imgLoading} />
      ) : (
        <FilterTypes>
          {filteredIdentifiers.map((type, index) => {
            const isSelected = selectedIdentifiers.some(
              identifier => identifier.placa === type.veiculo.placa
            )
            return (
              <ListItem key={`${type.veiculo.placa}-${index}`}>
                <IdentifierItem
                  blocked={editSelectionBlock}
                  typeValue={type.veiculo.placa}
                  name="placas"
                  label={type.veiculo.placa}
                  index={index}
                  isSelected={isSelected}
                />
              </ListItem>
            )
          })}
        </FilterTypes>
      )}
    </Content>
  )
}

export default IdentifierTable



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierTable.js